export enum Fichero {
  PDF = 'PDF',
  JPG = 'JPG',
  JPEG = 'JPEG',
  PNG = 'PNG'
}
/**
 * Tipos de ficheros
 */
